import { render, staticRenderFns } from "./micoapp_menu.vue?vue&type=template&id=89303f1a&scoped=true"
import script from "./micoapp_menu.vue?vue&type=script&lang=js"
export * from "./micoapp_menu.vue?vue&type=script&lang=js"
import style0 from "./micoapp_menu.vue?vue&type=style&index=0&id=89303f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89303f1a",
  null
  
)

export default component.exports